import { Component, OnDestroy } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { componentDestroyed, untilComponentDestroyed } from '../../helpers/rxjs.operator';



@Component({
    selector: 'diana-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnDestroy {
  public isVisible: boolean = false;

  constructor(private loaderService: LoaderService) {
    this.loaderService.getState()
    .pipe(untilComponentDestroyed(this))
    .subscribe(httpUrls => {
        this.isVisible = httpUrls && httpUrls.length > 0 ? true: false;
    });
  }

  ngOnDestroy(): void {
    componentDestroyed(this);
  }
}
